import script from "./Features.vue?vue&type=script&setup=true&lang=ts"
export * from "./Features.vue?vue&type=script&setup=true&lang=ts"

import "./Features.vue?vue&type=style&index=0&id=21fc265c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21fc265c"]])

export default __exports__